<template>
  <div class="overflow-x-auto">
    <t-table :headers="headers" :data="users" class="text-sm">
      <template slot="row" slot-scope="props">
        <tr>
          <td :class="props.tdClass">{{ props.row.name }}</td>
          <td
            v-for="(date, index) in dates"
            :key="index"
            :class="props.tdClass"
          >
            <template v-if="props.row[date]">
              <template v-for="(value, name, index) in props.row[date].time">
                <span
                  v-if="props.row[date]"
                  :class="isAvailable(props.row, date)"
                  :key="index"
                >
                  {{ index > 0 ? " &" : "" }}{{ value }}
                </span>
              </template>
            </template>
          </td>
          <td :class="props.tdClass">
            <span :class="{ 'text-red-500': props.row.total < 1 }">
              {{ props.row.total }}
            </span>
          </td>
          <td :class="props.tdClass">
            {{ props.row.total_per_week }}
          </td>
        </tr>
      </template>
    </t-table>
  </div>
</template>

<script>
import { get } from "lodash";

export default {
  name: "CheckRoosterTable",
  props: {
    headers: {
      type: Array,
      default() {
        return { headers: [] };
      },
    },
    users: {
      type: Array,
      default() {
        return { users: [] };
      },
    },
    dates: {
      type: Array,
      default() {
        return { dates: [] };
      },
    },
  },
  methods: {
    isAvailable(data, date) {
      return get(data, `${date}.times.available`, false) || "text-red-500";
    },
  },
};
</script>

<style lang="scss" scoped></style>
